<app-header [secondaryLogoUrl]="partnerDetails?.partnerMedia?.logo"></app-header>

<div class="container-fluid background-gray">
  <div class="row" *ngIf="totalFoundOptions()">
    <div class="col-xs-12 col-md-8 col-md-offset-2">
      <div class="row">
        <div class="col-xs-12">
          <p class="heading" id="congratulations">Here are your Indicative Eligible Loan Offer(s)</p>
        </div>
        <div class="col-xs-12">
          <p class="sub-heading">These offer(s) are based on the information that you have provided. Select
            one of the options below to continue with the loan application. Final loan offer will be
            communicated to you after a detailed credit decision. </p>
        </div>

        <div class="col-xs-12 mt-20px" *ngIf="partnerDetails.disbursalPreference !== 'borrower'">
                    <span class="sub-heading">
                        <b>NOTE:</b> The loan amount will be disbursed to <b>{{partnerDetails.partnerName}}</b>
                    </span>
        </div>

        <div class="col-xs-12">
          <p class="options-header">
            Here are the option(s) we have found for you based on the information you have provided:
          </p>

          <ng-container *ngFor="let option of defaultOptions">
            <app-option-row class="option-row" [option]="option"
                            (onApply)="applyForLoan($event)"></app-option-row>
          </ng-container>
        </div>

      </div>

      <div class="row" *ngIf="maximizedLoanAmountOptions.length">
        <div class="col-xs-12">
          <p class="options-header font-bold">
            We have also found a higher loan amount option(s) for you:
          </p>

          <ng-container *ngFor="let option of maximizedLoanAmountOptions">
            <app-option-row class="option-row" [option]="option"
                            (onApply)="applyForLoan($event)"></app-option-row>
          </ng-container>
        </div>
      </div>


    </div>
    <div class="col-xs-12 col-md-offset-2">
      <p class="disclaimer">No registration charges are applicable.<span
        *ngIf="!isProcessingFeeSubvented()"> A one-time processing fee is
                charged at the time of loan disbursal.</span></p>
    </div>
  </div>

  <div class="row" *ngIf="!totalFoundOptions()">
    <div class="col-xs-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 bg-white px-5 py-3 mt-3 text-center">
      <p class="small-heading">We don't have any pre-approved offers for you at the moment</p>
      <p class="paragraph py-9 mb-3">However, you can apply for a loan at finzy, by filling up a quick loan
        application
        form and providing us with some information and documents. We will get back to you with a decision
        within 24 working hours.</p>

      <button class="apply-now apply-button" (click)="applyForLoan()">Apply for a Loan</button>
    </div>
  </div>


</div>
